(() => {
  const connected = new WeakSet();
  const mobile = matchMedia('(max-width:749px)');
  function connect(root) {
    root.querySelectorAll('[data-charlox-gallery] media-gallery').forEach(gallery => {
      if (connected.has(gallery)) return;
      connected.add(gallery);
      gallery.querySelector('[id^="GalleryViewer-"]')?.addEventListener('slideChanged', event => {
        if (!mobile.matches || !event.target.id.startsWith('GalleryViewer-')) return;
        const active = event.detail?.currentElement;
        if (!active) return;
        gallery.querySelectorAll('.product__media-item').forEach(item => item.classList.toggle('is-active', item === active));
        const thumbnail = gallery.querySelector(`[data-target="${active.dataset.mediaId}"]`);
        if (thumbnail && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(document), {once:true});
  else connect(document);
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();
